/**
 * @export
 * Placeholder component for declarative sub-section definition within a DataEntrySection.
 * Does not render anything — props are extracted by DataEntryForm.
 *
 * @example
 * ```tsx
 * <DataEntrySection title="Step 1 - Personal">
 *   <DataEntrySubSection title="Basic Info" columns={2}>
 *     <DataEntryField field="firstName" title="First Name" required />
 *     <DataEntryField field="lastName" title="Last Name" required />
 *   </DataEntrySubSection>
 *   <DataEntrySubSection title="Address" separator>
 *     <DataEntryField field="city" title="City" />
 *   </DataEntrySubSection>
 * </DataEntrySection>
 * ```
 */
export const DataEntrySubSection = () => {
    return null;
};
